import React, {useState} from "react";
import Helmet from "react-helmet";
import Header from "./v2/header";
import Footer from "./v2/footer";

/** Import the css styles */
import "../styles/main.scss";

const Layout = (
  {
    bodyTheme = "light",
    className = "",
    headerLayout = "full",
    isFooter = true,
    children
  }
) => {
  const [bodyOverlay, setBodyOverlay] = useState('');

  const updateGlobalOverflow = (isHamburgerActive) => {
    setBodyOverlay(isHamburgerActive ? 'overlay' : '');
  }

  return (
    <>
      <Helmet
        htmlAttributes={{
          lang: 'en',
        }}
        bodyAttributes={{
          class: `${bodyTheme} ${bodyOverlay}`,
        }}
      />
      <Header
        hamburgerStateCallback = {updateGlobalOverflow}
        headerLayout = {headerLayout}
      />
      <main className={className}>
        {children}
      </main>
      {isFooter && (
        <Footer />
      )}
    </>
  )
}

export default Layout
